import Vue from 'vue'
import VueRouter from 'vue-router'
import nprogress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    redirect: '/Firstindex',// 默认路由
    children: [
      {
        path: '/Firstindex',
        name: 'Firstindex',
        component: () => import('../views/Firstindex.vue'),
        meta:{
          keepAlive: true,
        }
      },
      {
        path: '/spu',
        name: 'Spu',
        component: () => import('../views/Spu.vue')
      },
      {
        path: '/spuConfig',
        name: 'SpuConfig',
        component: () => import('../views/SpuConfig.vue')
      },
      {
        path: '/spuDetail',
        name: 'SpuDetail',
        component: () => import('../views/SpuDetail.vue'),
      },
      {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue')
      },
      {
        path: '/register',
        name: 'Register',
        component: () => import('../views/Register.vue'),
        meta: {
          keepAlive: true  // 需要缓存
        }
      },
      {
        path: '/userCenter',
        name: 'UserCenter',
        component: () => import('../components/UserCenter.vue')
      },
      {
        path: '/menu',
        name: 'Menu',
        component: () => import('../views/Menu.vue')
      },
      {
        path: '/userConfig',
        name: 'UserConfig',
        component: () => import('../views/UserConfig.vue')
      },
      {
        path: '/userFamily',
        name: 'UserFamily',
        component: () => import('../views/UserFamily.vue')
      },
      {
        path: '/order',
        name: 'Order',
        component: () => import('../views/Order.vue')
      },
      {
        path: '/userAddress',
        name: 'UserAddress',
        component: () => import('../views/UserAddress.vue')
      },
      {
        path: '/cgmUserVO',
        name: 'CgmUserVO',
        component: () => import('../views/CgmUserVO.vue')
      },
      {
        path: '/question',
        name: 'Question',
        component: () => import('../views/Question.vue')
      },
      {
        path: '/mobileOrder',
        name: 'MobileOrder',
        component: () => import('../components/MobileOrder.vue')
      },
      {
        path: '/service',
        name: 'Service',
        component: () => import('../components/Service.vue')
      },
      {
        path: '/track',
        name: 'Track',
        component: () => import('../components/Track.vue')
      },
      {
        path: '/address',
        name: 'Address',
        component: () => import('../components/Address.vue')
      },
      {
        path: '/addressInsert',
        name: 'AddressInsert',
        component: () => import('../components/AddressInsert.vue')
      },
      {
        path: '/modifyPassword',
        name: 'ModifyPassword',
        component: () => import('../components/ModifyPassword.vue')
      },
      {
        path: '/userNav',
        name: 'UserNav',
        component: () => import('../components/UserNav.vue')
      },
      {
        path: '/userSelf',
        name: 'UserSelf',
        component: () => import('../components/UserSelf.vue')
      },
      {
        path: '/userBody',
        name: 'UserBody',
        component: () => import('../components/UserBody.vue')
      },
      {
        path: '/familyInsert',
        name: 'FamilyInsert',
        component: () => import('../components/FamilyInsert.vue')
      },
      {
        path: '/spuAppend',
        name: 'SpuAppend',
        component: () => import('../components/SpuAppend.vue')
      },
      {
        path: '/Pay',
        name: 'Pay',
        component: () => import('../views/Pay.vue')
      },
      // {
      //   path: '/user',
      //   name: 'User',
      //   component: () => import('../views/User.vue'),
      //   redirect: '/order',// 默认路由
      //   children: [
      //     {
      //       path: '/order',
      //       name: 'Order',
      //       component: () => import('../views/Order.vue')
      //     },
      //     {
      //       path: '/cgmUserVO',
      //       name: 'cgmUserVO',
      //       component: () => import('../views/CgmUserVO.vue')
      //     }
      //   ]
      // }
    ]
  },
  {
    path:'/ConfigMedicine',
    name:"ConfigMedicine",
    component: () => import('../views/ConfigMedicine.vue'),
    meta:{
      keepAlive: true,
    }
  },
  {
    path:'/History',
    name:"History",
    component: () => import('../views/History.vue')
  },
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes,
  // scrollBehavior(to, from, savedPosition) {
  //   return { x: 0, y: 0 }
  // }
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})


router.beforeEach((to, from, next) => {
  nprogress.start()
  if (to.path == "/login") {
    if (store.state.cgmUserVO) {
      /**
       * 打回去
       */
      next(from.path)
      /**
       * 不执行afterEach
       */
      nprogress.done()
    } else {
      next();
    }
  } else {
    next();
  }
})

router.afterEach(() => {
  nprogress.done()
})

export default router
